module.exports = __webpack_public_path__ + "assets/img/step1.bc60a686.png";